import { Fragment, type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';

import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './SharedBottomModuleContent.scss';

import { type SharedBottomModuleContent_bottomModule$key } from './__generated__/SharedBottomModuleContent_bottomModule.graphql.ts';

const bottomModuleFragment = graphql`
    fragment SharedBottomModuleContent_bottomModule on BottomModule @relay(plural: true) {
        title
        description
    }
`;

type Props = {
    bottomModule: SharedBottomModuleContent_bottomModule$key;
};

export const SharedBottomModuleContent: FC<Props> = ({ bottomModule: bottomModuleRef }) => {
    const bottomModule = useFragment(bottomModuleFragment, bottomModuleRef);

    return bottomModule.map(item =>
        item.title && item.description ? (
            <Fragment key={item.title}>
                <HeadingLevel>
                    {Heading => (
                        <Heading
                            className={classnames(
                                dibsCss.sassyFontBodySmallHeavy,
                                dibsCss.mtSmall,
                                dibsCss.m0
                            )}
                        >
                            {item.title}
                        </Heading>
                    )}
                </HeadingLevel>
                <div
                    className={classnames(styles.description, dibsCss.sassyFontBodySizeSmall)}
                    dangerouslySetInnerHTML={{ __html: item.description }}
                />
            </Fragment>
        ) : null
    );
};
